// Promotions
import React from 'react';
import styles from './Promotions.module.sass';
import { CreatorLevelProgress } from 'types/profile';
import ImageKitImage from 'components/common/ImageKitImage';
import { TIER_DESCRIPTIONS } from 'constants/profile';

export interface PromotionsProps extends CreatorLevelProgress {}

const Promotions: React.FC<PromotionsProps> = ({
  level: { name: levelName, upperBoundCompletedCampaigns, image, description },
  completedPartnershipCount,
}) => {
  const progress = completedPartnershipCount / upperBoundCompletedCampaigns;

  return (
    <div className={styles.promotions}>
      <div className={styles.tierCard}>
        <div className={styles.tierHeader}>
          <img src={image} alt="tier award" />
          <div>
            <div className={styles.tierRow}>
              <p>{levelName}</p>
              <p>
                {completedPartnershipCount}/{upperBoundCompletedCampaigns}
              </p>
            </div>
            <div className={styles.tierSubtitle}>
              <p>Level</p>
              <p>Project Completions</p>
            </div>
            <div className={styles.progress}>
              <span style={{ width: `${progress * 100}%` }} />
            </div>
          </div>
        </div>
        <div className={styles.tierNameRow}>
          <div>
            <p>Trend Starter</p>
            <p>Project bonus</p>
          </div>
          <div>
            <p>
              {upperBoundCompletedCampaigns - completedPartnershipCount} more
            </p>
            <p>Projects until promotion</p>
          </div>
        </div>
        <p>{description}</p>
      </div>
      <div className={styles.tierExplanationCard}>
        <p>
          Everyone is eligible for all promotions and corresponding bonuses. You
          must maintain a 4.0 star rating to be eligible for level upgrades.
        </p>
        <hr />
        <div>
          <TierDescription tier="silver" />
          <TierDescription tier="gold" />
          <TierDescription tier="diamond" />
        </div>
      </div>
    </div>
  );
};

export default Promotions;

interface TierDescriptionProps {
  tier: 'silver' | 'gold' | 'diamond';
}

const TierDescription: React.FC<TierDescriptionProps> = ({ tier }) => {
  const { image, range, bonus } = TIER_DESCRIPTIONS[tier];
  return (
    <div className={styles.tierDescription}>
      <ImageKitImage
        path={image}
        // transformation={[{ width: '40' }]}
      />
      <div>
        <p>{range} Project Completions</p>
        <p>
          {tier}: {bonus > 0 ? `$${bonus} project bonus` : 'Trend Starter'}
        </p>
      </div>
    </div>
  );
};
